import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProduceMovementRecord,
  searchProductsforJITOrder,
  fetchPMRJITConfiguration,
  fetchDiscrepancyList
} from "./ProduceMovementAndRecord.AsyncThunk";
import {
  handleFullFillForFetchProduceMomentData,
  handlePendingForFetchProduceMomentData,
  handleRejectForFetchProduceMomentData,
  updateDailySalesForDeleteAll,
  AddItemToProduceMovementRecord,
  setSelectedItems,
  initialState,
  handlePendingSearchProductForJITorder,
  handleFulfillSearchProductForJITorder,
  handleRejectSearchProductForJITorder,
  handleClearSearchResult,
  setForecastSales,
  setActualSales,
  setOrderFactor,
  setCasesPerThousand,
  setItemInventory,
  setItemReceivedValue,
  setWeekEnd,
  setRowData,
  setDepartment,
  resetToDefault,
  handlePendingPMRJITConfiguration,
  handleFullFillPMRJITConfiguration,
  handleRejectPMRJITConfiguration,
  setBlockNavigation,
  setSubClasses,
  setOrderWindow,
  setMasterDisplay,
  resetToInitialState,
  handlePendingDiscrepancyList,
  handleFullFillDiscrepancyList,
  handleRejectDiscrepancyList,
  setPackSizeValue,
  resetAfterSave,
  setFilteredCommodities
} from "./ProduceMovementAndRecord.Reducer";

const produceMovementRecordData = createSlice({
  name: "produceMovementRecordData",
  initialState,
  reducers: {
    resetProduceMovementRecord() {
      return initialState;
    },
    setProduceMovementRecordSearchResults(state, action) {
      state.searchProductListData.searchResults = action.payload;
    },
    updateDailySalesForDeleteAll,
    AddItemToProduceMovementRecord,
    handleClearSearchResult,
    setSelectedItems,
    setForecastSales,
    setActualSales,
    setOrderFactor,
    setCasesPerThousand,
    setMasterDisplay,
    setItemInventory,
    setItemReceivedValue,
    setWeekEnd,
    setRowData,
    setDepartment,
    resetToDefault,
    setBlockNavigation,
    setSubClasses,
    setOrderWindow,
    setPackSizeValue,
    resetToInitialState,
    resetAfterSave,
    setFilteredCommodities
  },
  extraReducers(builder) {
    builder
      .addCase(
        searchProductsforJITOrder.pending,
        handlePendingSearchProductForJITorder
      )
      .addCase(
        searchProductsforJITOrder.fulfilled,
        handleFulfillSearchProductForJITorder
      )
      .addCase(
        searchProductsforJITOrder.rejected,
        handleRejectSearchProductForJITorder
      )
      .addCase(
        fetchProduceMovementRecord.pending,
        handlePendingForFetchProduceMomentData
      )
      .addCase(
        fetchProduceMovementRecord.fulfilled,
        handleFullFillForFetchProduceMomentData
      )
      .addCase(
        fetchProduceMovementRecord.rejected,
        handleRejectForFetchProduceMomentData
      )
      .addCase(
        fetchPMRJITConfiguration.pending,
        handlePendingPMRJITConfiguration
      )
      .addCase(
        fetchPMRJITConfiguration.fulfilled,
        handleFullFillPMRJITConfiguration
      )
      .addCase(
        fetchPMRJITConfiguration.rejected,
        handleRejectPMRJITConfiguration
      )
      .addCase(fetchDiscrepancyList.pending, handlePendingDiscrepancyList)
      .addCase(fetchDiscrepancyList.fulfilled, handleFullFillDiscrepancyList)
      .addCase(fetchDiscrepancyList.rejected, handleRejectDiscrepancyList);
  }
});

export const {
  resetProduceMovementRecord,
  updateDailySalesForDeleteAll: handleRemoveAll,
  handleClearSearchResult: clearSearchResults,
  AddItemToProduceMovementRecord: addItemToProduceMovementRecord,
  setSelectedItems: updateSelectedItems,
  setForecastSales: updateForecastSales,
  setActualSales: updateActualSales,
  setOrderFactor: updateOrderFactor,
  setCasesPerThousand: updateCasesPerThousand,
  setMasterDisplay: updateMasterDisplay,
  setItemInventory: updateItemInventory,
  setItemReceivedValue: updateItemReceivedValue,
  setWeekEnd: updateWeekEnd,
  setRowData: updateRowData,
  setDepartment: updateDepartment,
  resetToDefault: resetToDefaultState,
  setBlockNavigation: updateBlockNavigation,
  setSubClasses: updateSubClasses,
  setOrderWindow: updateOrderWindow,
  setPackSizeValue: updatePackSizeValue,
  resetToInitialState: resetToInitialStateFunction,
  resetAfterSave: resetAfterSaveFunction,
  setFilteredCommodities: setFilteredCommoditiesFunction
} = produceMovementRecordData.actions;

export default produceMovementRecordData.reducer;
